<script lang="ts">
	import { Badge } from '$lib/components/ui/badge';
	import { ChevronRightIcon } from 'lucide-svelte';
	import { fade } from 'svelte/transition';
	import { PUBLIC_CDN_URL, PUBLIC_LOL_CDN_URL } from '$env/static/public';
	import { cn } from '$lib/utils';
	import GuiToolbar from '../gui-toolbar.svelte';
	import { Separator } from '$lib/components/ui/separator';

	interface SkillOrder {
		[key: number]: string;
	}

	interface StatMod {
		icon: string;
		active: boolean;
	}

	let className: string = '';
	export { className as class };

	let latestPatch = '14.22';

	const skillOrder: SkillOrder = {
		0: 'Q',
		3: 'Q',
		4: 'Q',
		6: 'Q',
		8: 'Q',
		19: 'W',
		31: 'W',
		32: 'W',
		34: 'W',
		35: 'W',
		38: 'E',
		43: 'E',
		45: 'E',
		47: 'E',
		48: 'E',
		59: 'R',
		64: 'R',
		69: 'R'
	};

	const mainTree = {
		icon: '/lol/img/perk-images/Styles/7200_Domination.png',
		active: false
	};

	const mainTreeKeystones = [
		{
			icon: '/lol/img/perk-images/Styles/Domination/Electrocute/Electrocute.png',
			active: true
		},
		{
			icon: '/lol/img/perk-images/Styles/Domination/Predator/Predator.png',
			active: false
		},
		{
			icon: '/lol/img/perk-images/Styles/Domination/HailOfBlades/HailOfBlades.png',
			active: false
		},
		{
			icon: '/lol/img/perk-images/Styles/Domination/DarkHarvest/DarkHarvest.png',
			active: false
		}
	];

	const mainTreeItems = [
		[
			{
				icon: '/lol/img/perk-images/Styles/Domination/CheapShot/CheapShot.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Domination/TasteOfBlood/GreenTerror_TasteOfBlood.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Domination/SuddenImpact/SuddenImpact.png',
				active: true
			}
		],
		[
			{
				icon: '/lol/img/perk-images/Styles/Domination/ZombieWard/ZombieWard.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Domination/GhostPoro/GhostPoro.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Domination/EyeballCollection/EyeballCollection.png',
				active: true
			}
		],
		[
			{
				icon: '/lol/img/perk-images/Styles/Domination/TreasureHunter/TreasureHunter.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Domination/IngeniousHunter/IngeniousHunter.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Domination/RelentlessHunter/RelentlessHunter.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Domination/UltimateHunter/UltimateHunter.png',
				active: true
			}
		]
	];

	const statMods: StatMod[][] = [
		[
			{
				icon: '/lol/img/perk-images/StatMods/StatModsAdaptiveForceIcon.png',
				active: true
			},
			{
				icon: '/lol/img/perk-images/StatMods/StatModsAttackSpeedIcon.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/StatMods/StatModsCDRScalingIcon.png',
				active: false
			}
		],
		[
			{
				icon: '/lol/img/perk-images/StatMods/StatModsAdaptiveForceIcon.png',
				active: true
			},
			{
				icon: '/lol/img/perk-images/StatMods/StatModsMovementSpeedIcon.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/StatMods/StatModsHealthPlusIcon.png',
				active: false
			}
		],
		[
			{
				icon: '/lol/img/perk-images/StatMods/StatModsHealthScalingIcon.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/StatMods/StatModsTenacityIcon.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/StatMods/StatModsHealthPlusIcon.png',
				active: true
			}
		]
	];

	const offTree = {
		icon: '/lol/img/perk-images/Styles/7204_Resolve.png',
		active: false
	};

	const offTreeItems = [
		[
			{
				icon: '/lol/img/perk-images/Styles/Resolve/Demolish/Demolish.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Resolve/FontOfLife/FontOfLife.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Resolve/MirrorShell/MirrorShell.png',
				active: false
			}
		],
		[
			{
				icon: '/lol/img/perk-images/Styles/Resolve/Conditioning/Conditioning.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Resolve/SecondWind/SecondWind.png',
				active: true
			},
			{
				icon: '/lol/img/perk-images/Styles/Resolve/BonePlating/BonePlating.png',
				active: false
			}
		],
		[
			{
				icon: '/lol/img/perk-images/Styles/Resolve/Overgrowth/Overgrowth.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Resolve/Revitalize/Revitalize.png',
				active: false
			},
			{
				icon: '/lol/img/perk-images/Styles/Sorcery/Unflinching/Unflinching.png',
				active: false
			}
		]
	];
</script>

<div
	class={cn(
		'relative flex h-[850px] w-full flex-col items-center rounded-lg border border-darkTertiary bg-darkPrimaryAlt px-5 py-2 shadow-lg backdrop-blur lg:w-[640px]',
		className
	)}
>
	<GuiToolbar class="h-2.5 w-auto" />
	<div class="flex h-full w-full">
		<div class="flex h-full w-full flex-col items-center justify-center">
			<div
				class={cn('flex h-full w-full max-w-4xl flex-col items-start justify-start gap-6 py-10')}
			>
				<div
					in:fade={{ duration: 300 }}
					class="flex w-full flex-row items-start justify-start gap-3"
				>
					<div
						class="flex h-8 max-h-7 min-h-7 w-7 min-w-7 max-w-9 overflow-hidden rounded-full bg-darkQuaternary pt-0.5 shadow-glow shadow-darkQuaternary drop-shadow-lg transition-all"
					>
						<img
							src={`${PUBLIC_CDN_URL}/meeko/meeko_1.png?fm=webp`}
							class="block h-9 max-h-9 w-auto object-cover p-1"
							alt="Meeko"
						/>
					</div>
					<div class="flex w-full flex-col items-start justify-start gap-1">
						<span class="text-xs font-light text-lightTertiary">Meeko</span>
						<div
							in:fade={{ duration: 300 }}
							class="flex w-full flex-col items-start justify-center gap-3 pr-12"
						>
							<p class="max-w-xl text-xs text-lightSecondary">
								On <span class="font-medium text-primary">Patch {latestPatch}</span>, I've analyzed
								48,185 games and the over-all build with the highest win rate is the following:
							</p>
							<!-- Tier List -->
							<div
								class="flex h-auto w-full flex-col items-center justify-center overflow-hidden rounded-lg bg-darkSecondary"
							>
								<div
									class="mb-4 flex w-full flex-row flex-wrap justify-between gap-2 bg-darkTertiary px-4 py-2 font-light text-lightTertiary sm:items-center"
								>
									<div
										class="flex w-full items-center justify-evenly gap-1 rounded-lg bg-darkPrimaryAlt py-0.5 pl-0.5 pr-1 sm:w-auto"
									>
										<button
											class="pointer-events-none w-full cursor-default rounded-md bg-darkTertiary px-3 py-1 text-xs text-lightPrimary"
											>Recommended</button
										>
										<button
											class="pointer-events-none w-full cursor-default rounded-md px-3 py-1 text-xs text-lightTertiary"
											>Popular</button
										>
									</div>
									<div
										class="flex w-full flex-col gap-2 py-2 text-xs sm:mt-0 sm:w-auto sm:flex-row sm:items-center sm:justify-end"
									>
										<span class="text-nowrap">Highest win rate build</span>
										<Separator
											class="hidden h-4 w-[1px] bg-darkQuaternary sm:inline-block"
											orientation="vertical"
										/>
										<Separator
											class="inline-block h-[1px] w-full bg-darkQuaternary sm:hidden"
											orientation="horizontal"
										/>
										<span class="hidden text-nowrap sm:block"
											>Patch <Badge
												class="ml-0.5 border border-primary bg-darkTertiary px-1.5 py-1 text-xs font-light text-primary"
												>{latestPatch}</Badge
											></span
										>
										<span class="block text-nowrap sm:hidden"
											>Patch <span class="text-primary">{latestPatch}</span></span
										>
									</div>
								</div>
								<div
									class="flex h-full w-full flex-col items-start justify-start gap-8 overflow-hidden md:hidden"
								>
									<div class="grid w-full grid-cols-12 items-start justify-start gap-8 px-4">
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-xs font-normal text-lightSecondary">Skill priority</span>
											<div class="flex flex-row items-center gap-1">
												<div
													class="relative m-0 h-7 min-h-7 w-7 min-w-7 flex-shrink-0 rounded-md border border-darkQuaternary p-0"
												>
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliQ.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill 1"
													/>
													<div
														class="absolute bottom-0 right-0 rounded-br-md bg-darkTertiary px-1 text-[9px] text-lightPrimary"
													>
														Q
													</div>
												</div>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<div
													class="relative m-0 h-7 min-h-7 w-7 min-w-7 flex-shrink-0 rounded-md border border-darkQuaternary p-0"
												>
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliE.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill 2"
													/>
													<div
														class="absolute bottom-0 right-0 rounded-br-md bg-darkTertiary px-1 text-[9px] text-lightPrimary"
													>
														E
													</div>
												</div>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<div
													class="relative m-0 h-7 min-h-7 w-7 min-w-7 flex-shrink-0 rounded-md border border-darkQuaternary p-0"
												>
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliW.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill 3"
													/>
													<div
														class="absolute bottom-0 right-0 rounded-br-md bg-darkTertiary px-1 text-[9px] text-lightPrimary"
													>
														W
													</div>
												</div>
											</div>
										</div>
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary"
												>Summoner Spells</span
											>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/spell/SummonerFlash.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Spells 1"
												/>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/spell/SummonerTeleport.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Spells 2"
												/>
											</div>
										</div>
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Starting Items</span
											>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/1056.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Starting 1"
												/>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/2003.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Starting 2"
												/>
											</div>
										</div>
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Core build</span>
											<div class="flex flex-row items-center gap-1">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3020.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Core 1"
												/>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3100.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Core 2"
												/>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/4645.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Core 3"
												/>
											</div>
										</div>
									</div>
									<div class="grid w-full grid-cols-12 items-start justify-start gap-8 px-4">
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Item 4</span>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3157.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 4_1"
												/>
												<span class="text-[11px] text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3041.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 4_2"
												/>
											</div>
										</div>
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Item 5</span>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3157.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 5_1"
												/>
												<span class="text-xs text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3089.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 5_2"
												/>
												<span class="text-xs text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3041.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 5_3"
												/>
											</div>
										</div>
									</div>
									<div class="grid w-full grid-cols-12 items-start justify-start gap-8 px-4">
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Item 6</span>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3089.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 6_1"
												/>
												<span class="text-[11px] text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3157.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 6_2"
												/>
												<span class="text-[11px] text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3041.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 6_3"
												/>
											</div>
										</div>
									</div>
									<div
										class="grid w-full grid-cols-12 items-start justify-start gap-8 border-darkQuaternary px-4 pb-6"
									>
										<div class="col-span-4 flex w-32 flex-col justify-center gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Main Tree</span>
											<div
												class="flex flex-row items-center gap-1.5 pb-1 pt-1 text-xs text-lightPrimary"
											>
												<img
													src={PUBLIC_CDN_URL + mainTree.icon + '?fm=webp'}
													class="m-0 h-5 min-h-5 w-5 min-w-5 rounded-full object-cover p-0"
													alt="Domination"
												/> Domination
											</div>
											<div class="mt-1 grid w-full grid-cols-4 grid-rows-1 gap-2">
												{#each mainTreeKeystones as keystone, i}
													<img
														src={PUBLIC_CDN_URL + keystone.icon + '?fm=webp'}
														class={cn(
															'm-0 h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
															!keystone.active && 'opacity-30 grayscale'
														)}
														alt={`Keystone ${i + 1}`}
													/>
												{/each}
											</div>
											<div class="flex w-full items-center justify-center">
												<div class="grid grid-cols-3 grid-rows-2 place-items-center gap-2">
													{#each mainTreeItems as row, i}
														{#if i !== 2}
															{#each row as item}
																<img
																	src={PUBLIC_CDN_URL + item.icon + '?fm=webp'}
																	class={cn(
																		'm-0 h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
																		!item.active && 'opacity-30 grayscale'
																	)}
																	alt={`mainTreeItem ${i + 1}`}
																/>
															{/each}
														{/if}
													{/each}
												</div>
											</div>
											<div class="grid w-full grid-cols-4 grid-rows-1 gap-2">
												{#each mainTreeItems as row, i}
													{#if i == 2}
														{#each row as item}
															<img
																src={PUBLIC_CDN_URL + item.icon + '?fm=webp'}
																class={cn(
																	'm-0 h-6 min-h-6 w-6 min-w-6  rounded-full border border-lightQuaternary object-cover p-0',
																	!item.active && 'opacity-30 grayscale'
																)}
																alt={`mainTreeItem ${i + 1}`}
															/>
														{/each}
													{/if}
												{/each}
											</div>
										</div>
										<div class="col-span-3 flex w-28 flex-col gap-1">
											<span class="text-[11px] font-normal text-lightSecondary">Off Tree</span>
											<div
												class="flex flex-row items-center gap-1.5 pb-1 pt-1 text-xs text-lightPrimary"
											>
												<img
													src={PUBLIC_CDN_URL + offTree.icon + '?fm=webp'}
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Resolve"
												/> Resolve
											</div>
											<div class="mt-1 grid w-full grid-cols-3 grid-rows-3 gap-2">
												{#each offTreeItems as row, i}
													{#each row as item}
														<img
															src={PUBLIC_CDN_URL + item.icon + '?fm=webp'}
															class={cn(
																'm-0  h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
																!item.active && 'opacity-30 grayscale'
															)}
															alt={`offTree ${i + 1}`}
														/>
													{/each}
												{/each}
											</div>
										</div>
										<div class="col-span-5 flex w-28 flex-col gap-1">
											<span class="text-[11px] font-normal text-lightSecondary">Stat Mods</span>
											<div class="grid w-full grid-cols-3 grid-rows-1 gap-1 pb-1 pt-1">
												<im
													src={`${PUBLIC_CDN_URL}/lol/img/perk-images/StatMods/StatModsAdaptiveForceIcon.png?fm=webp`}
													g
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Adaptive Force"
												/>
												<img
													src={`${PUBLIC_CDN_URL}/lol/img/perk-images/StatMods/StatModsAdaptiveForceIcon.png?fm=webp`}
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Adaptive Force"
												/>
												<img
													src={`${PUBLIC_CDN_URL}/lol/img/perk-images/StatMods/StatModsHealthPlusIcon.png?fm=webp`}
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Adaptive Force"
												/>
											</div>
											<div class="mt-1 grid w-full grid-cols-3 grid-rows-3 gap-2">
												{#each statMods as statModGroup, index}
													{#each statModGroup as statMod, subIndex}
														<img
															src={PUBLIC_CDN_URL + statMod.icon + '?fm=webp'}
															class={cn(
																'm-0  h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
																!statMod.active && 'opacity-30 grayscale'
															)}
															alt={`StatMod ${index + 1} ${subIndex + 1}`}
														/>
													{/each}
												{/each}
											</div>
										</div>
									</div>
								</div>
								<div
									class="hidden h-full w-full flex-col items-start justify-start gap-8 overflow-x-scroll md:flex"
								>
									<div class="grid w-full grid-cols-12 items-start justify-start gap-8 px-4">
										<div class="col-span-4 flex flex-col gap-2">
											<span class="text-xs font-normal text-lightSecondary">Skill priority</span>
											<div class="flex flex-row items-center gap-1">
												<div
													class="relative m-0 h-7 min-h-7 w-7 min-w-7 flex-shrink-0 rounded-md border border-darkQuaternary p-0"
												>
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliQ.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill 1"
													/>
													<div
														class="absolute bottom-0 right-0 rounded-br-md bg-darkTertiary px-1 text-[9px] text-lightPrimary"
													>
														Q
													</div>
												</div>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<div
													class="relative m-0 h-7 min-h-7 w-7 min-w-7 flex-shrink-0 rounded-md border border-darkQuaternary p-0"
												>
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliE.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill 2"
													/>
													<div
														class="absolute bottom-0 right-0 rounded-br-md bg-darkTertiary px-1 text-[9px] text-lightPrimary"
													>
														E
													</div>
												</div>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<div
													class="relative m-0 h-7 min-h-7 w-7 min-w-7 flex-shrink-0 rounded-md border border-darkQuaternary p-0"
												>
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliW.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill 3"
													/>
													<div
														class="absolute bottom-0 right-0 rounded-br-md bg-darkTertiary px-1 text-[9px] text-lightPrimary"
													>
														W
													</div>
												</div>
											</div>
										</div>
										<div class="col-span-3 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary"
												>Summoner Spells</span
											>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/spell/SummonerFlash.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Spells 1"
												/>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/spell/SummonerTeleport.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Spells 2"
												/>
											</div>
										</div>
										<div class="col-span-5 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Starting Items</span
											>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/1056.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Starting 1"
												/>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/2003.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Starting 2"
												/>
											</div>
										</div>
									</div>
									<div class="grid w-full grid-cols-12 items-start justify-start gap-8 px-4">
										<div class="col-span-4 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Core build</span>
											<div class="flex flex-row items-center gap-1">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3020.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Core 1"
												/>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3100.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Core 2"
												/>
												<ChevronRightIcon class="h-3 w-3 text-lightTertiary" />
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/4645.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Core 3"
												/>
											</div>
										</div>
										<div class="col-span-3 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Item 4</span>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3157.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 4_1"
												/>
												<span class="text-[11px] text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3041.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 4_2"
												/>
											</div>
										</div>
										<div class="col-span-5 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Item 5</span>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3157.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 5_1"
												/>
												<span class="text-xs text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3089.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 5_2"
												/>
												<span class="text-xs text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3041.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 5_3"
												/>
											</div>
										</div>
									</div>
									<div class="grid w-full grid-cols-12 items-start justify-start gap-8 px-4">
										<div class="col-span-12 flex flex-col gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Item 6</span>
											<div class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3089.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 6_1"
												/>
												<span class="text-[11px] text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3157.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 6_2"
												/>
												<span class="text-[11px] text-lightTertiary">or</span>
												<img
													src={`${PUBLIC_LOL_CDN_URL}/item/3041.png?fm=webp`}
													class="m-0 h-7 w-7 rounded-md border border-darkQuaternary object-cover p-0"
													alt="Item 6_3"
												/>
											</div>
										</div>
									</div>
									<div
										class="grid w-full grid-cols-12 items-start justify-start gap-8 border-darkQuaternary px-4 pb-6"
									>
										<div class="col-span-4 flex w-32 flex-col justify-center gap-2">
											<span class="text-[11px] font-normal text-lightSecondary">Main Tree</span>
											<div
												class="flex flex-row items-center gap-1.5 pb-1 pt-1 text-xs text-lightPrimary"
											>
												<img
													src={PUBLIC_CDN_URL + mainTree.icon + '?fm=webp'}
													class="m-0 h-5 min-h-5 w-5 min-w-5 rounded-full object-cover p-0"
													alt="Domination"
												/> Domination
											</div>
											<div class="mt-1 grid w-full grid-cols-4 grid-rows-1 gap-2">
												{#each mainTreeKeystones as keystone, i}
													<img
														src={PUBLIC_CDN_URL + keystone.icon + '?fm=webp'}
														class={cn(
															'm-0 h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
															!keystone.active && 'opacity-30 grayscale'
														)}
														alt={`Keystone ${i + 1}`}
													/>
												{/each}
											</div>
											<div class="flex w-full items-center justify-center">
												<div class="grid grid-cols-3 grid-rows-2 place-items-center gap-2">
													{#each mainTreeItems as row, i}
														{#if i !== 2}
															{#each row as item}
																<img
																	src={PUBLIC_CDN_URL + item.icon + '?fm=webp'}
																	class={cn(
																		'm-0 h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
																		!item.active && 'opacity-30 grayscale'
																	)}
																	alt={`mainTreeItem ${i + 1}`}
																/>
															{/each}
														{/if}
													{/each}
												</div>
											</div>
											<div class="grid w-full grid-cols-4 grid-rows-1 gap-2">
												{#each mainTreeItems as row, i}
													{#if i == 2}
														{#each row as item}
															<img
																src={PUBLIC_CDN_URL + item.icon + '?fm=webp'}
																class={cn(
																	'm-0 h-6 min-h-6 w-6 min-w-6  rounded-full border border-lightQuaternary object-cover p-0',
																	!item.active && 'opacity-30 grayscale'
																)}
																alt={`mainTreeItem ${i + 1}`}
															/>
														{/each}
													{/if}
												{/each}
											</div>
										</div>
										<div class="col-span-3 flex w-28 flex-col gap-1">
											<span class="text-[11px] font-normal text-lightSecondary">Off Tree</span>
											<div
												class="flex flex-row items-center gap-1.5 pb-1 pt-1 text-xs text-lightPrimary"
											>
												<img
													src={PUBLIC_CDN_URL + offTree.icon + '?fm=webp'}
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Resolve"
												/> Resolve
											</div>
											<div class="mt-1 grid w-full grid-cols-3 grid-rows-3 gap-2">
												{#each offTreeItems as row, i}
													{#each row as item}
														<img
															src={PUBLIC_CDN_URL + item.icon + '?fm=webp'}
															class={cn(
																'm-0  h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
																!item.active && 'opacity-30 grayscale'
															)}
															alt={`offTree ${i + 1}`}
														/>
													{/each}
												{/each}
											</div>
										</div>
										<div class="col-span-5 flex w-28 flex-col gap-1">
											<span class="text-[11px] font-normal text-lightSecondary">Stat Mods</span>
											<div class="grid w-full grid-cols-3 grid-rows-1 gap-1 pb-1 pt-1">
												<img
													src={`${PUBLIC_CDN_URL}/lol/img/perk-images/StatMods/StatModsAdaptiveForceIcon.png?fm=webp`}
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Adaptive Force"
												/>
												<img
													src={`${PUBLIC_CDN_URL}/lol/img/perk-images/StatMods/StatModsAdaptiveForceIcon.png?fm=webp`}
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Adaptive Force"
												/>
												<img
													src={`${PUBLIC_CDN_URL}/lol/img/perk-images/StatMods/StatModsHealthPlusIcon.png?fm=webp`}
													class="m-0 h-6 min-h-6 w-6 min-w-6 rounded-full object-cover p-0"
													alt="Adaptive Force"
												/>
											</div>
											<div class="mt-1 grid w-full grid-cols-3 grid-rows-3 gap-2">
												{#each statMods as statModGroup, index}
													{#each statModGroup as statMod, subIndex}
														<img
															src={PUBLIC_CDN_URL + statMod.icon + '?fm=webp'}
															class={cn(
																'm-0  h-6 min-h-6 w-6 min-w-6 rounded-full border border-lightQuaternary object-cover p-0',
																!statMod.active && 'opacity-30 grayscale'
															)}
															alt={`StatMod ${index + 1} ${subIndex + 1}`}
														/>
													{/each}
												{/each}
											</div>
										</div>
									</div>
								</div>
								<div
									class="flex w-full flex-row items-start justify-between gap-4 bg-darkTertiary p-6"
								>
									<div class="flex flex-col gap-2 pr-4">
										<span class="text-[11px] font-normal text-lightSecondary">Skill Order</span>
										<div class="flex flex-row gap-1">
											<div class="grid grid-cols-1 grid-rows-4 gap-1">
												<div class="relative m-0 h-6 w-6 rounded-md border border-darkTertiary p-0">
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliQ.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill Order 1"
													/>
												</div>
												<div class="relative m-0 h-6 w-6 rounded-md border border-darkTertiary p-0">
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliE.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill Order 2"
													/>
												</div>
												<div class="relative m-0 h-6 w-6 rounded-md border border-darkTertiary p-0">
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliW.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill Order 3"
													/>
												</div>
												<div class="relative m-0 h-6 w-6 rounded-md border border-darkTertiary p-0">
													<img
														src={`${PUBLIC_LOL_CDN_URL}/spell/AkaliR.png?fm=webp`}
														class="m-0 w-full rounded-md object-cover p-0"
														alt="Skill Order 4"
													/>
												</div>
											</div>
											<div class="skill-order-grid grid w-full grid-rows-4 gap-1">
												{#each Array(72).fill(null) as _, i}
													<div
														class="flex h-6 w-6 items-center justify-center rounded-md border border-darkQuaternary bg-darkPrimary p-0 text-[11px] font-light text-lightSecondary"
													>
														{#if skillOrder[i] !== undefined}
															{skillOrder[i]}
														{/if}
													</div>
												{/each}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
